module.exports = __webpack_public_path__ + "media/images/home/main/uzdevumi-631393cc79f59ee87841b5e7a0e4c285.png";